var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.437,
    height: 13,
    viewBox: "0 0 14.437 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Error_4372697",
    transform: "translate(-1.99 -2.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(1.99 2.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11544",
    "data-name": "Path 11544",
    d: "M16.334,14.893,9.84,3.349a.722.722,0,0,0-1.255,0L2.091,14.893a.722.722,0,0,0,.628,1.09H15.707a.722.722,0,0,0,.628-1.075ZM8.491,8.768a.722.722,0,0,1,1.443,0v2.165a.722.722,0,1,1-1.443,0Zm.722,5.051a.722.722,0,1,1,.722-.722A.722.722,0,0,1,9.213,13.818Z",
    transform: "translate(-1.99 -2.983)",
    fill: "#ec3330"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.5a7ceec3.svg";
export { ForwardRef as ReactComponent };